export default "__VITE_ASSET__1506adca__"